import { Criterion, ParticipantField, ParticipantFieldType } from '@app/api';
import { FormInputType } from '@app/participant-fields';
import { CriterionSelect } from './participantFields/CriterionSelect';
import { CriterionRange } from './participantFields/CriterionRange';
import { CriterionLocaleSelect } from './participantFields/CriterionLocaleSelect';
import { CriterionText } from './participantFields/CriterionText';
import { CriterionMagicSelect } from './participantFields/CriterionMagicSelect';
import { DeprecatedGeolocationCriterionGate } from './participantFields/DeprecatedGeolocationCriterionGate';

const criterionFieldInputMap: Record<
  ParticipantFieldType,
  FormInputType<Criterion> | null
> = {
  [ParticipantFieldType.EMAIL]: null,
  [ParticipantFieldType.PHONE_NUMBER]: null,
  [ParticipantFieldType.SINGLE_CHOICE]: CriterionMagicSelect,
  [ParticipantFieldType.MULTIPLE_CHOICE]: CriterionSelect,
  [ParticipantFieldType.TAGS]: null,
  [ParticipantFieldType.SHORT_TEXT]: CriterionText,
  [ParticipantFieldType.LONG_TEXT]: null,
  [ParticipantFieldType.DATE]: CriterionRange,
  [ParticipantFieldType.NUMBER]: CriterionRange,
  [ParticipantFieldType.GEOLOCATION]: DeprecatedGeolocationCriterionGate,
  [ParticipantFieldType.INCOME]: null,
  [ParticipantFieldType.TIMEZONE]: null,
  [ParticipantFieldType.LOCALES]: CriterionLocaleSelect,
  [ParticipantFieldType.BOOLEAN]: null,
};

export const getCriterionFieldInput = (
  field: ParticipantField,
): FormInputType<Criterion> | null => {
  return criterionFieldInputMap[field.type];
};

export const isFieldHandledForCriterion = (field: ParticipantField) =>
  !!getCriterionFieldInput(field);

export const isFieldHandleQuota = (field: ParticipantField) =>
  field.type === ParticipantFieldType.SINGLE_CHOICE ||
  field.type === ParticipantFieldType.DATE;
